<template>
    <div id="app">
        <vue-progress-bar/>
        <router-view/>
        <notifications/>
    </div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch('diagram/getDiagram');
  },
};
</script>

<style lang="scss">
    @import "./assets/scss/variables";
    @import "../node_modules/bootstrap/scss/bootstrap";
    @import "../node_modules/bootstrap-vue/dist/bootstrap-vue.min.css";
    @import "./assets/scss/app";
</style>
